import { Route, Switch, Redirect } from 'react-router-dom';

import BookingDetailsPage from 'pages/BookingDetailsPage';
import NotFoundPage from 'pages/NotFoundPage';
import CancellationQuotePage from 'pages/CancellationQuotePage';
import BookingListPage from 'pages/BookingListPage';
import ChangeDatesRequestPage from 'pages/ChangeDatesRequestPage';
import PrintViewPage from 'pages/PrintViewPage';
import ChangeDatesPage from 'pages/ChangeDatesPage';
import BookingRoute from 'components/BookingRoute';

const Route404Page = () => <NotFoundPage />;

export default (
  <Switch>
    <Route path="/" exact render={() => <Redirect to={{ pathname: '/bookings' }} />} />
    <BookingRoute path="/bookings/:bookingId/cancellation-quote/:stage?" component={CancellationQuotePage} />
    <BookingRoute path="/bookings/:bookingId/change-date-request/:stage?" component={ChangeDatesRequestPage} />
    <BookingRoute path="/bookings/:bookingId/change-date/:stage?" component={ChangeDatesPage} />
    <BookingRoute path="/bookings/:bookingId/print" component={PrintViewPage} />
    <BookingRoute path={['/bookings/:bookingId', '/business/bookings/:bookingId']} component={BookingDetailsPage} />
    <Route path="/bookings" component={BookingListPage} />
    <Route path="*" component={Route404Page} />
  </Switch>
);
